import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-briefcase-icon',
    templateUrl: './briefcase-icon.component.html',
    styleUrls: ['./briefcase-icon.component.scss']
})
export class BriefcaseIconComponent extends AbstractIcon {

    constructor() {
        super();

        this.height = 38;
        this.width = 40;
    }
}
